import { makeStyles } from '@rneui/themed'
import { useRoutingContext } from 'app/routing_context'
import { SummaryItem } from 'home/types'
import { TileItemDescription } from 'home/views/tiles/items/description'
import React from 'react'
import { Pressable } from 'react-native'

interface MonthlySummaryDescriptionItemContentProps {
  item: SummaryItem
  color?: string
  error?: Error
}

export function MonthlySummaryDescriptionItemContent({
  item,
  color,
  error,
}: MonthlySummaryDescriptionItemContentProps) {
  const styles = useStyles(color)
  const { handleNavigation } = useRoutingContext()

  return (
    <Pressable
      onPress={() => {
        handleNavigation({
          routeName: 'settings',
          routeParams: { type: 'store' },
        })
      }}
    >
      <TileItemDescription
        description={item.description}
        error={error}
        textStyle={styles.description}
      />
    </Pressable>
  )
}

const useStyles = makeStyles((theme, color: string | undefined) => ({
  description: {
    fontSize: 8,
    marginHorizontal: 16,
    marginVertical: 10,
    color: color,
  },
}))
